import { render, staticRenderFns } from "./AhaSlidesGPTTouchPoint.vue?vue&type=template&id=817d0f36&"
import script from "./AhaSlidesGPTTouchPoint.vue?vue&type=script&lang=js&"
export * from "./AhaSlidesGPTTouchPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports